import { render, staticRenderFns } from "./CbsDomainSkeleton.vue?vue&type=template&id=51ef3bea"
import script from "./CbsDomainSkeleton.vue?vue&type=script&lang=js"
export * from "./CbsDomainSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports